import React from "react";
import LinkButton from "new-ui/Button/LinkButton";

const NavigationLinkButton = ({ children, path }) => (
  <LinkButton className="w-100 tl" variant="text" path={path} noPadding>
    {children}
  </LinkButton>
);

export default NavigationLinkButton;